import { useMemo } from 'react'
import { Box } from '@mui/material'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import { useStreamTextReveal } from '@/features/chat/streaming/useStreamTextReveal'
import { safeHref } from '../InlineFormat/safeHref'
import { blockComponents } from './blockComponents'
import { inlineComponents } from './inlineComponents'
import { markdownRootSx } from './markdownRootSx'
import { tableComponents } from './tableComponents'
import styles from './markdownStreaming.module.scss'

const PLUGINS = [remarkGfm]

/**
 * @param {{ text: string, citations?: Array<{ marker: number }>, streaming?: boolean }} props
 */
export default function MarkdownRenderer({ text, citations = [], streaming = false }) {
  const components = useMemo(
    () => ({
      ...blockComponents(citations),
      ...inlineComponents(citations),
      ...tableComponents(citations),
    }),
    [citations],
  )
  const { displayText, isRevealing } = useStreamTextReveal(text, streaming)
  const value = String(displayText ?? '')
  if (!value.trim()) return null

  return (
    <Box
      className={isRevealing ? styles.revealing : styles.settled}
      sx={markdownRootSx}
      aria-busy={streaming || undefined}
    >
      <ReactMarkdown
        remarkPlugins={PLUGINS}
        components={components}
        urlTransform={(url) => safeHref(url) ?? ''}
      >
        {value}
      </ReactMarkdown>
    </Box>
  )
}
